import { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { MotionAspectRatio } from "utils/motion";
import { useRouter } from "next/router";

// YouTube requires "pt-br" for Brazilian Portuguese, while Next.js uses "pt"
const resolveYoutubeLocale = (locale) => (locale === "pt" ? "pt-br" : locale);

const YoutubeEmbed = ({ id, ...props }) => {
  const { locale } = useRouter();
  const lang = resolveYoutubeLocale(locale);
  const [isMounted, setIsMounted] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted || loaded) return;
    const timer = setTimeout(() => setBlocked(true), 4000);
    return () => clearTimeout(timer);
  }, [isMounted, loaded]);

  if (!isMounted) return null;

  if (blocked) {
    return (
      <MotionAspectRatio ratio={16 / 9} {...props}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap="16px"
          bg="black"
        >
          <Box as="p" color="white" textAlign="center" fontSize="sm" m={0}>
            Video blocked by a browser extension.
          </Box>
          <Box
            as="a"
            href={`https://www.youtube.com/watch?v=${id}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            color="primary"
            textDecoration="underline"
            fontSize="sm"
          >
            Watch on YouTube ↗
          </Box>
        </Box>
      </MotionAspectRatio>
    );
  }

  return (
    <MotionAspectRatio ratio={16 / 9} {...props}>
      <Box
        as="iframe"
        src={`https://www.youtube.com/embed/${id}?rel=0&hl=${lang}&cc_lang_pref=${lang}&cc=1`}
        allowFullScreen
        maxH={props.maxH || "90vh"}
        onLoad={() => setLoaded(true)}
      />
    </MotionAspectRatio>
  );
};

export default YoutubeEmbed;
